import React, { Component, PropTypes } from 'react';
import CorporateQuoteApi from '../../../api/CorporateQuoteApi';

import SummaryPage from '../components/summary/SummaryPage';
import ConfirmationMessage from './components/Confirmation/ConfirmMessage';
import QuoteApprovalActionConfirm from './components/QuoteApprovalActionConfirm';

import { formateSummary, getMessage, statusReference } from '../helper';

//let status={value: '', label: ''};
/**
 * QuoteSummary
 *
 * quote summary is the container for the final view in the Corporate Quote
 * creation flow. It requests data from the quoteSummary api endpoint to
 * populate the various presentational components.
 */
class QuoteSummary extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fetchingSummary: true,
      showConfirmPopup: false,
      quoteStatus: 0,
      showConfirmation: false,
      quoteId: '',
      responseStatus: { value: '', label: '' },
      isError: false,
      canApprove: false,
      canReject: false,
      docuSign: false
      // errorObject: { isError: false, errorMessage: 'Sorry, what you are looking for cannot be found!'}
    };
  }

  componentDidMount() {
    const token = this.props.location.query.token;

    CorporateQuoteApi.getQuoteSummaryForApproval(token)
      .then(data => {
        if (data.success) {
          const result = data.data;
          this.setState({ ...formateSummary(result) });
          this.setState({
            fetchingSummary: false
          });
          this.setState({
            quoteId: result.Quote.QuoteId,
            canApprove: result.CanApprove,
            canReject: result.CanReject,
            docuSign: result.Docusign
          });
        } else {
          let responseStatus = {};
          const isError = !this.state.isError;
          this.setState({ isError });
          responseStatus.value = statusReference.ERROR;
          responseStatus.label = 'Sorry, what you are looking for cannot be found!';
          this.setState({ responseStatus });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleApproveQuotePopup = () => {
    //IF DOCUSIGN Directly redirect to new page instead of popup
    if (this.state.docuSign) {
      CorporateQuoteApi.approveQuoteSummaryForApproval(
        this.props.location.query.token,
        statusReference.APPROVED,
        ''
      )
        .then(data => {
          const redirectURL = data.RedirectTo;
          window.open(redirectURL, '_blank');
        })
        .catch(err => {
          throw err;
        });
    } else {
      this.toggleConfirmPopup(statusReference.APPROVED);
    }
  };

  closeApprove = () => {};

  handleDeclineQuotePopup = () => {
    this.toggleConfirmPopup(statusReference.DECLINED);
  };

  handleConfirm = reason => {
    console.log('handle confirm ' + reason);
    this.toggleConfirmPopup();

    CorporateQuoteApi.approveQuoteSummaryForApproval(
      this.props.location.query.token,
      this.state.quoteStatus,
      reason
    )
      .then(data => {
        const showConfirmation = !this.state.showConfirmation;
        this.setState({ showConfirmation });

        let responseStatus = {};

        switch (this.state.quoteStatus) {
          case statusReference.APPROVED:
            responseStatus.value = statusReference.APPROVED;
            responseStatus.label = 'You have approved this quote';
            break;
          case statusReference.DECLINED:
            responseStatus.value = statusReference.DECLINED;
            responseStatus.label = 'You have declined this quote';
            break;
          default:
            responseStatus = null;
        }
        this.setState({ responseStatus });
      })
      .catch(err => {
        throw err;
      });
  };

  /**
   * toggleConfirmPopup
   * when the user wants to change vehicles, we need to warn them it will
   * start a new quote, so show them a confirm dialog
   <SummaryPage {...this.state}
          approveQuote={this.openApprove}
          declineQuote={this.openDecline}/>
   */
  toggleConfirmPopup = quoteStatus => {
    const showConfirmPopup = !this.state.showConfirmPopup;
    this.setState({ showConfirmPopup });
    if (quoteStatus) this.setState({ quoteStatus });
  };

  onCloseWindow = () => {
    window.open('location', '_self', '');
    window.close();
  };

  render() {
    const decisionActions = {
      approveAction: this.handleApproveQuotePopup,
      declineAction: this.handleDeclineQuotePopup,
      canApprove: this.state.canApprove,
      canReject: this.state.canReject
    };

    return (
      <section>
        {!this.state.showConfirmation &&
          !this.state.isError &&
          <div>
            <SummaryPage {...this.state} decisionActions={decisionActions} />
            <QuoteApprovalActionConfirm
              onConfirm={this.handleConfirm}
              onCancel={this.toggleConfirmPopup}
              isOpen={this.state.showConfirmPopup}
              action={this.state.quoteStatus}
            />
          </div>}
        {this.state.showConfirmation &&
          !this.state.isError &&
          <ConfirmationMessage
            quoteId={this.state.quoteId}
            messageDetail={getMessage(this.state.responseStatus.value)}
            status={this.state.responseStatus}
            closeWindow={this.onCloseWindow}
          />}
        {this.state.isError &&
          <ConfirmationMessage
            quoteId={this.state.quoteId}
            messageDetail={getMessage(this.state.responseStatus.value)}
            status={this.state.responseStatus}
            closeWindow={this.onCloseWindow}
          />}
      </section>
    );
  }
}

QuoteSummary.propTypes = {
  location: PropTypes.object
};

QuoteSummary.contextTypes = {
  router: PropTypes.object
};

export default QuoteSummary;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/QuoteSummary.js